<template>
  <section class="percentages-or-combos">
    <section class="btn-group">
      <button
        class="btn btn-default"
        v-bind:class="{ active: percentagesOrCombos === 'percentages' }"
        v-on:click="$emit('toggle', 'percentages')"
      >
        Percentages
      </button>
      <button
        class="btn btn-default"
        v-bind:class="{ active: percentagesOrCombos === 'combos' }"
        v-on:click="$emit('toggle', 'combos')"
      >
        Combos
      </button>
    </section>
    <section v-if="percentagesOrCombos === 'combos'" class="bg-warning">
      {{ numberOfSpecificHandsInRange.roundToOneDecimalPlace() }} / {{ numberOfPossibleSpecificHands.roundToOneDecimalPlace() }} combos selected
    </section>
  </section>
</template>

<script>
export default {
  name: 'percentages-or-combos',
  props: ['percentagesOrCombos', 'numberOfSpecificHandsInRange', 'numberOfPossibleSpecificHands'],
};
</script>

<style lang="scss" scoped>
  .bg-warning {
    margin-top: 10px;
    padding: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/five-card-hands-section/percentages-or-combos.vue